import React from 'react';
import PropTypes from 'prop-types';

import ShareControl from '../../controls/mapping/ShareControl';

const ShareSection = (props) => {
  const { selectedItemList, isDisabled } = props;
  return (
    <ShareControl
      detailCurrentItemsSelection={selectedItemList}
      isDisabled={isDisabled}
    />
  );
};

ShareSection.propsTypes = {
  selectedItemList: PropTypes.array,
};

export default ShareSection;
